import { render, staticRenderFns } from "./reportAlert.vue?vue&type=template&id=c72c1b22"
import script from "./reportAlert.vue?vue&type=script&lang=js"
export * from "./reportAlert.vue?vue&type=script&lang=js"
import style0 from "./reportAlert.vue?vue&type=style&index=0&id=c72c1b22&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./reportAlert.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports